import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import JsonForm from '../forms/json-form';
import { jsonValidationSchema } from '../schema/json.js';

export default function JsonNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'JSON Node Details',
        altText: 'JSON Node',
        defaultLabel: 'JSON Node',
      }}
    >
      <CommonNode FormComponent={JsonForm} schemaResolver={jsonValidationSchema} />
    </NodeProvider>
  );
}
